const typeList = [{
  id: 1,
  name: '图片'
}, {
  id: 2,
  name: '视频'
}, {
  id: 3,
  name: '图标'
}]

export const getList = (num) => {
  let list = []
  if (num > 0) {
    list = typeList.filter(res => {
      let number = (res.id - 1)
      let newVar = num >> number
      let number1 = newVar & 1
      return number1
    })
  }
  return list
}
